// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"265":"canvg","297":"xlsx","643":"pdfmake"}[chunkId] || chunkId) + "." + {"265":"68ba9f59","297":"a2753fb3","643":"56336686","743":"1a1bf5c3"}[chunkId] + ".chunk.js";
};